// import version from './lib/version';
import './_includes/foundation';
import inView from 'in-view';
import '@fancyapps/fancybox';

let ignoreOnBeforeUnload = false;

// ////////////////////////////////////////////////////////////
// init foundation
const body = document.body,
    $menuButton = $('.menu-toggle'),
    offCanvasTransition = $('.off-canvas').data('transition'),
    $scrollUp = $('.scroll-up'),
    $sideNav = $('.side-nav'),
    classes = {
        inView: 'js-is-inview',
        sideNavEvaded: 'side-nav--evaded',
    };

// show focus style only after a tab keystroke
function handleFirstTab(event) {
    if (event.keyCode === 9) {
        body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
    }
}

window.addEventListener('keydown', handleFirstTab);

// fade out on page leave
$('a[href^="mailto"], a[href^="tel"], a[download], .download, a[href^="javascript:"]').on('click', () => {
    ignoreOnBeforeUnload = true;
});

window.addEventListener('beforeunload', () => {
    if (!ignoreOnBeforeUnload) {
        body.classList.add('body--fade-out');
    }

    ignoreOnBeforeUnload = false;
});

$('a[aria-disabled="true"]').on('click', event => {
    event.preventDefault();
    event.stopImmediatePropagation();
});

function getYoutubeID(url) {
    let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#]*).*/,
        match = url.match(regExp);

    return (match && match[7].length == 11) ? match[7] : false;
}

function createYoutubeNoCookieUrl(url) {
    return 'https://www.youtube-nocookie.com/embed/' + getYoutubeID(url);
}

$(document)
    .foundation()
    .on('opened.zf.offcanvas', () => {
        $menuButton.addClass('is-active');
    })
    .on('closed.zf.offcanvas', () => {
        $menuButton.removeClass('is-active');
    })
    .ready(function () {
        let $youtubeLink = $('a.video[data-fancybox]');

        if ($youtubeLink.length) {
            $youtubeLink.each(function () {
                let $url = $(this).attr('href');

                $(this).attr('href', createYoutubeNoCookieUrl($url));
            });
        }
    });

if (offCanvasTransition && offCanvasTransition === 'push') {
    // this is only required, if the header is supposed to be pushed too
    body.classList.add('is-off-canvas-push');
}

// scroll top
$(window)
    .on('scroll', () => {
        let scrollTop = Math.max(document.documentElement.scrollTop, body.scrollTop);

        if (scrollTop >= 400 && !$scrollUp.data('isVisible')) {
            // display needs to be set explicitly to 'block', so we need to mimic the 'fadeIn' method
            // display: block; is required to maintain paddings etc. in the side-nav
            $scrollUp.parent().removeClass('hide');
            $scrollUp
                .css({
                    display: 'block',
                    opacity: 0,
                })
                .data('isVisible', true)
                .stop()
                .fadeTo('fast', 1);
        } else if (scrollTop < 400) {
            $scrollUp
                .data('isVisible', false)
                .stop()
                .fadeOut('fast', () => {
                    if ($scrollUp.parent().is('.side-nav__link')) {
                        // only hide the parent, when the scroll-up-link is in the side-nav
                        $scrollUp.parent().addClass('hide');
                    }
                });
        }
    });

// you can listen to breakpoint changes like so:
// $(window).on('changed.zf.mediaquery', (event, current, old) => {
//    console.log(`Breakpoint changed from "${old}" to "${current}"`);
// });

// ////////////////////////////////////////////////////////////
// manage side-nav visibility
inView('.footer')
    .on('enter', () => {
        $sideNav.addClass(classes.sideNavEvaded);
    })
    .on('exit', () => {
        $sideNav.removeClass(classes.sideNavEvaded);
    });

// ////////////////////////////////////////////////////////////
// sliding header
import './lib/headroom';

// ////////////////////////////////////////////////////////////
// form helpers
import './lib/form/form';

// ////////////////////////////////////////////////////////////
// masonry
import './lib/layouts/masonry';

// ////////////////////////////////////////////////////////////
// swiper
import './lib/layouts/swiper';

// ////////////////////////////////////////////////////////////
// map
import './lib/layouts/map';

// ////////////////////////////////////////////////////////////
// update url based on scrolling
import ScrollNav from './lib/scroll-nav';

// ////////////////////////////////////////////////////////////
// set anchor scrolling only on glossary page
if ($('#glossary').length) {

    // anchor scrolling
    if (CONFIG.scrollFromHashChanges !== true) {
        new Foundation.SmoothScroll($('a[href*="#"]:not([href="#"]):not(.no-scroll)'));
    } else {
        $('a[href*="#"]:not([href="#"]):not(.no-scroll)').on('click', event => {
            event.preventDefault(); // do not allow setting the hash, as some browser move directly to the target, before the onhashchange event is triggered

            let target = event.currentTarget,
                href = target.href,
                currentPathName = window.location.pathname.replace(/\/$/, ''),
                hrefPathName = href
                    .replace(/^.*\/\/[^/]+/, '')
                    .replace(/#.*/, '')
                    .replace(/\/$/, '');

            // get the actual hash of the href
            if (href && href.indexOf('#') !== -1) {
                href = href.split('#').pop();
            }

            // mask the hash so that browsers don't navigate
            if (href && href[0] !== '/') {
                href = '/' + href;
            }

            if (currentPathName !== hrefPathName) {
                window.location.href = target.href; // change url if anchor is on another page
            } else {
                location.hash = href; // set hash explicitly to trigger the onhashchange event, on which scrolling depends
            }
        });
    }

    setTimeout(() => {
        new ScrollNav({
            scrollFromHashChanges: CONFIG.scrollFromHashChanges || false,
            getHash(el) {
                return '/' + (el.getAttribute('data-scrollnav-anchor') || el.id);
            },
            getActiveStateSelector(hash) {
                return `[href="#${hash.replace(/^#?\//, '')}"]`;
            },
            getAttribute(hash) {
                return hash.replace(/#\//, '');
            },
        });
    }, 1);
}

// ////////////////////////////////////////////////////////////
// fancybox
$('.lightbox, .video')
    .not('html') // safari sometimes gets the html element for the first selector when it would return an empty collection instead
    .fancybox();

$('.has-video').on('click', function () {
    $.fancybox.open([
        {
            src: $(this).data('src'),
            type: 'inline',
            opts: {
                smallBtn: false,
            },
        },
    ]);
});

// ////////////////////////////////////////////////////////////
// Workaround to disable first element in a select field for cf7
if ($('.wpcf7-form option').length) {
    $('.wpcf7-form option:nth-child(1), option:nth-child(1)').attr('disabled', 'disabled');
    $('.wpcf7-form option:nth-child(1), option:nth-child(1)').val('');
}

// ////////////////////////////////////////////////////////////
// browser alerts (async)
require(['./lib/alerts/old-browser'], oldBrowserAlert => {
    oldBrowserAlert.default();
});


// ////////////////////////////////////////////////////////////
// Leady tracking code (copied and adjusted from typo3 website)
/* eslint-disable */
function extractHostname(url) {
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname

    if (url.indexOf("://") > -1) {
        hostname = url.split('/')[2];
    }
    else {
        hostname = url.split('/')[0];
    }

    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];

    return hostname;
}

function extractRootDomain(url) {
    var domain = extractHostname(url),
        splitArr = domain.split('.'),
        arrLen = splitArr.length;

    //extracting the root domain here
    if (arrLen > 2) {
        domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
    }

    return domain;
}

function getLeadyTrackKey() {
    switch (extractRootDomain(window.location.href)) {
        case "editel.at":
            return "fJzYdLd7OKJD2039";

        case "editel.eu":
            return "a8a1F1P034GnDt49";

        case "editel.cz":
            return "jZ7y8Z412k2UJJQ3";

        case "editel.hr":
            return "PU7cV27Ac2nBVDJl";

        case "editel.hu":
            return "7WyLm0Oy4QXL8GdI";

        case "editel.sk":
            return "Qinj0PN5H073d9i8";

        case "editel.pl":
            return "THRTq7ifMIk62CYZ";

        default:
            return "";
    }
}

// gets called by cookie manager on user opt-in
window.loadLeady = function() {
    var l=document.createElement("script");l.type="text/javascript";l.async=true;
    l.src='https://t.leady.com/'+getLeadyTrackKey()+"/L.js";
    var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(l,s);
};

// currently included via header / footer plugin because of not working local environment
// TODO: remove comment & plugin when local enviornment is working correctly again
// scroll to first appearance of form error after invalid cf7 form
if (document.querySelector('.wpcf7-form.invalid')) {
    if (document.querySelector('.wpcf7-form .has-error')) {
        jQuery('html, body').animate({
            scrollTop: (
                // element.offset.top - element.height - header.height
                jQuery('.wpcf7-form .has-error').first().offset().top - jQuery('.wpcf7-form .has-error').first().height() - jQuery('.header').height()
            )
        });
    } else {
        // Google recaptcha - doesn't ues error label --> instead scroll to submit button to show cf7 response message
        jQuery('html, body').animate({
            scrollTop: (
                // submit.offset.top - submit.height - header.height
                jQuery('.wpcf7-form .wpcf7-submit').offset().top - jQuery('.wpcf7-form .wpcf7-submit').outerHeight() - jQuery('.header').height()
            )
        });
    }
} else if(document.querySelector('.wpcf7-form.unaccepted')) {
    if (document.querySelector('.wpcf7-form .wpcf7-response-output').textContent !== '') {
        // GDPR checkbox doesn't ues error label --> instead scroll to submit button to show cf7 response message
        jQuery('html, body').animate({
            scrollTop: (
                // submit.offset.top - submit.height - header.height
                jQuery('.wpcf7-form .wpcf7-submit').offset().top - jQuery('.wpcf7-form .wpcf7-submit').outerHeight() - jQuery('.header').height()
            )
        });
    }
}

// check if browser is loaded from bfcache
window.addEventListener('pageshow', (event) => {
    if (event.persisted === true) {
        // remove class for fading animation to prevent seeing blank page
        body.classList.remove('body--fade-out');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js